
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/other-hazardous-waste",
      function () {
        return require("private-next-pages/other-hazardous-waste/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/other-hazardous-waste"])
      });
    }
  